module.exports = __webpack_public_path__ + "static/satoshi-dice-header-transparent-e4621067994134bca386e2f270ecf408.png";